import { AiFillPlusCircle } from "react-icons/ai";
import clostIcon from "../../assets/images/add-circle.png";

const AddButton = ({
  btnName = "",
  btnContent = "",
  addBtn = false,
  btnClassName = "",
  isIcon = true,
  onClick = () => {},
}) => {
  return (
    <>
      {addBtn ? (
        <div
          className="flexRow addBtnWrapper bgPrimary addBtn"
          onClick={onClick}
        >
          {isIcon ? <img src={clostIcon} alt="addBtn" /> : null}
          <button className="bgPrimary border-0 text-white">
            {btnContent}
          </button>
        </div>
      ) : (
        <div onClick={onClick} className="addNewbtn px-3">
          <div>
            {/* <img src={buttonadd} alt="" /> */}
            <AiFillPlusCircle color="#4E91C2" size={25} />
          </div>
          <div className="ms-1">
            <button className={btnClassName}>{btnName}</button>
          </div>
        </div>
      )}
    </>
  );
};

export default AddButton;
